exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (min-width: 700px) {\n  .posFix {\n    position: fixed !important; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/itheunrealist/techpixels/src/app/app.component.scss
// module id = ../../../../../src/app/app.component.scss
// module chunks = main